<div class="center-xy">
    <div class='statistics__loading' *ngIf="loading">
        <div class="statistics__loading__img">
            <loader></loader>
        </div>
    </div>
    <div class="statistics-wrapper">
        <div class="statistics-wrapper__statistics bg-light" data-testid="statistics-view">
            <img class="statistics__icon bg-style bg-style__icon border-light"
                 ngSrc="/assets/img/id_icons/74.svg"
                 priority="true"
                 width="72" height="72" alt="">
            <div class="statistics__title bg-style color-light font-24 font-bold">
                {{ subtitle(1089) }}
            </div>
            <div class="statistics__switch-buttons"></div>
            <div class="statistics-flex">
                @if (statisticsTemp.isDynamicEnergyYield() || statisticsTemp.isColumnOccurrence()) {
                    <select class="chart-buttons__button--selectBox"
                            data-testid="select-yield-type"
                            [(ngModel)]="statistics.state"
                            (change)="stateToggle()">
                        <option value="temperatures">{{ subtitle(4496) }}</option>
                        @if(statisticsTemp.isColumnOccurrence()) {
                            @if (statisticsTemp.columnsOccurrence.yields_flag) {
                                <option value="yields">{{ subtitle(2446) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.consumptions_flag) {
                                <option value="consumptions">{{ subtitle(4802) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.warm_delivered_flag) {
                                <option value="warm_delivered">{{ subtitle(4211) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.cold_delivered_flag) {
                                <option value="cold_delivered">{{ subtitle(4836) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.supply_fan_energy_consumption_flag) {
                                <option value="supply_fan_energy_consumption">{{ subtitle(10843) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.exhaust_fan_energy_consumption_flag) {
                                <option value="exhaust_fan_energy_consumption">{{ subtitle(10844) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.preliminary_heater_energy_consumption_flag) {
                                <option value="preliminary_heater_energy_consumption">{{ subtitle(10845) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.energy_acquired_gwc_flag) {
                                <option value="energy_acquired_gwc">{{ subtitle(10846) }}</option>
                            }
                            @if (statisticsTemp.columnsOccurrence.temperature_efficiency_flag) {
                                <option value="temperature_efficiency">{{ subtitle(6093) }}</option>
                            }
                        }
                        @if(statisticsTemp.isDynamicEnergyYield()) {
                            @for (column of statisticsTemp.columnsOccurrence.dynamic; track column.objectId) {
                                <option [ngValue]="column">{{ subtitle(column.txtId) }}</option>
                            }
                        }
                    </select>
                }

                @if(statistics.state === 'temperatures') {
                    <select [(ngModel)]="statistics.timePeriod" data-testid="select-temp-period"
                        class="chart-buttons__button--selectBox">
                        <option value="day">{{ subtitle(1236) }}</option>
                        <option value="week">{{ subtitle(1237) }}</option>
                        <option value="month">{{ subtitle(392) }}</option>
                    </select>
                }

                @if (statistics.state !== 'temperatures' && (
                        statisticsTemp.isDynamicEnergyYield() || statisticsTemp.isColumnOccurrence())) {
                    <select [(ngModel)]="statistics.timePeriod"
                            data-testid="select-yield-period"
                            class="chart-buttons__button--selectBox">
                            @if (isStatisticsScope('hour')) {
                                <option value="hour">{{ subtitle(1236) }}</option>
                            }
                            @if (isStatisticsScope('week')) {
                                <option value="week">{{ subtitle(1237) }}</option>
                            }
                            @if (isStatisticsScope('day')) {
                                <option value="day">{{ subtitle(1739) }}</option>
                            }
                            @if (isStatisticsScope('month')) {
                                <option value="month">{{ subtitle(1740) }}</option>
                            }
                            @if (isStatisticsScope('year')) {
                                <option value="year">{{ subtitle(4776) }}</option>
                            }
                            @if (isStatisticsScope('total')) {
                                <option value="total">{{ subtitle(732) }}</option>
                            }
                    </select>
                }

                <div class="statistics__chart-buttons">
                    <select class="chart-buttons__button--selectBox"
                        data-testid="select-months"
                        [disabled]="statistics.timePeriod !== 'month'
                            || statistics.state !== 'temperatures'
                            || statistics.isDynamicYields()"
                        [ngClass]="{ 'statistics-bg-grey': statistics.timePeriod !== 'month'
                            || statistics.state !== 'temperatures'
                            || statistics.isDynamicYields() }"
                        [(ngModel)]="statistics.selectedMonth"
                        (change)="statistics.timePeriod = 'month'">
                        <option *ngFor="let month of months" [value]="month.index">
                            {{ month.value }}
                        </option>
                    </select>
                    <select class="chart-buttons__button--selectBox"
                        data-testid="select-years"
                        [disabled]="statistics.timePeriod !== 'month'
                            && statistics.timePeriod !== 'year'
                            || statistics.state !== 'temperatures'
                            || statistics.isDynamicYields()"
                        [ngClass]="{ 'statistics-bg-grey': statistics.timePeriod !== 'month'
                            && statistics.timePeriod !== 'year'
                            || statistics.state !== 'temperatures'
                            || statistics.isDynamicYields() }"
                        [(ngModel)]="statistics.selectedYear">
                        <option *ngFor="let year of years" [value]="year">
                            {{ year }}
                        </option>
                    </select>
                </div>
                <button class="chart-buttons__button bg-gradient"
                    (click)="generateChart(); loading=true;"
                    [disabled]="statistics.singleClick">
                    {{ subtitle(1238) }}
                </button>
            </div>

            <div class="statistics__chart-wrapper">
                <div id="chartContainer"></div>
            </div>

            <div class="statistics__alert"
                *ngIf="!loading">
                <div>{{ statistics.messageContent }}</div>
            </div>

            <div class="wrapper__download-csv">
                <select [ngModel]="statistics.chartMode()"
                        (ngModelChange)="onChartModeChange($event)"
                        data-testid="select-chart-scheme"
                        class="chart-buttons__button--selectBox chart-buttons__button--selectBox--narrow">
                    <option value="light">{{ subtitle(3737) }}</option>
                    <option value="dark">{{ subtitle(3738) }}</option>
                </select>
                <button class="chart-buttons__button bg-gradient"
                    *ngIf="statistics.currentGeneratedType === 'temperatures'"
                    (click)="showHideAllCharts(true)">
                    {{ subtitle(3706) }}
                </button>
                <button class="chart-buttons__button bg-gradient"
                    *ngIf="statistics.currentGeneratedType === 'temperatures'"
                    (click)="showHideAllCharts(false)">
                    {{ subtitle(4885) }}
                </button>
                <button class="chart-buttons__button bg-gradient"
                    (click)="downloadCsv()">
                    {{ subtitle(3480) + ' CSV' }}
                </button>
            </div>
        </div>
    </div>
</div>
